/* @flow */

import React from 'react';
import { Message, Card } from 'semantic-ui-react';
import OctoResourceImage from 'shared/components/OctoResourceImage';

type Props = {
  content: GalleryContent,
};

const View = ({ content }: Props) => {
  if (content.items && content.items.length) {
    return (
      <Card.Group itemsPerRow={4}>
        {content.items.map(i => (
          <Card key={i.order}>
            <OctoResourceImage resource={i.image} />
          </Card>
        ))}
      </Card.Group>
    );
  }

  return <Message icon="info" header="Aucune image dans la galerie" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/gallery/View.js